<template>
  <spinner-container :loading="loading">
    <bread-cump :cumps="$route.meta.breadcrumps" :params="$route.params" />

    <v-container fluid>
      <v-card class="card--shadow">
        <v-card-text>
          <div class="d-flex justify-space-between">
            <p>
              Month: {{ $route.query.month }} / Year: {{ $route.query.year }}
            </p>
            <p>{{ $route.query.township_name?$route.query.township_name:null }}</p>
            <export-monthly
              :datas="generatedData"
              :townshipName="$route.query.township_name?$route.query.township_name:$route.query.township_group_name"
            />
          </div>
        </v-card-text>
        <v-simple-table fixed-header height="100vh">
          <template>
            <thead>
              <tr>
                <th class="text-left">Sr No</th>
                <th class="text-left">Indicators</th>
                <th class="text-left">Male</th>
                <th class="text-left">Female</th>
                <th class="text-left">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in generatedData" :key="index">
                <td>{{ item.counter }}</td>
                <td>{{ item.title }}</td>
                <td :class="{ black_box: item.data.female == null }">
                  {{ item.data.male }}
                </td>
                <td :class="{ black_box: item.data.male == null }">
                  {{ item.data.female }}
                </td>
                <td v-if="item.data.female != null && item.data.male != null">
                  {{ Number(item.data.male) + Number(item.data.female) }}
                </td>
                <td v-else>
                  {{ item.data }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-container>
  </spinner-container>
</template>

<script>
import { mapState } from "vuex";
import BreadCump from "@/components/navigation/BreadCump.vue";
import SpinnerContainer from "@/components/container/SpinnerContainer.vue";
import ExportMonthly from "@/components/report/monthly/ExportMonthly";

export default {
  components: { SpinnerContainer, BreadCump, ExportMonthly },
  data: () => ({
    no: 0,
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Report", ["datas"]),
    generatedData() {
      var data = [];
      var counter = 0;
      if (!this.loading) {
        Object.entries(this.datas).forEach(([key, value]) => {
          counter++;
          data.push({
            counter: counter,
            data: value,
            title: key,
          });
        });
      }
      return data;
    },
  },
  created() {
    this.$store.dispatch("Report/getMonthly", {
      month: this.$route.query.month,
      year: this.$route.query.year,
      township_id: this.$route.query.township_id,
      township_group_id:this.$route.query.township_group_id,
      filterby:this.$route.query.filterby
    });
  },
};
</script>

<style scoped>
.black_box {
  background: #181313;
  border: 1px solid #353131;
}
</style>


